<template>
  <div class="time-range-setting">
    <BaseElForm>
      <BaseElFormItem :label="$t('dailyView.timeRange.startTimeLabel')" :placeholder="$t('dailyView.timeRange.selectStartTime')">
        <BaseElSelect v-model="formData.start" @change="formData.end = null">
          <BaseElSelectOption
            v-for="time in timeOptions"
            :key="time"
            :label="time"
            :value="time"
          />
        </BaseElSelect>
      </BaseElFormItem>
      <BaseElFormItem :label="$t('dailyView.timeRange.endTimeLabel')" :placeholder="$t('dailyView.timeRange.selectEndTime2')">
        <BaseElSelect v-model="formData.end" :disabled="!formData.start" @change="onRangeChange">
          <BaseElSelectOption
            v-for="time in endOptions"
            :key="time"
            :label="time"
            :value="time"
          />
        </BaseElSelect>
      </BaseElFormItem>
    </BaseElForm>
  </div>
</template>

<script>
import { defineComponent, computed, ref, onMounted } from 'vue'
import { timeToNumber } from '@/utils/helper'
import { FindReservationParameter } from '@/api/reservation'
import { useStorage } from '@vueuse/core'
import store from '@/store'
import { generateFormatPeriod } from '@/utils/time'

export default defineComponent({
  name: 'TimeRangeSetting',
  setup (props, { emit }) {
    const timeUnit = ref(60)
    const timeOffset = ref(0)
    const formData = useStorage('dailyViewSettings', {
      start: '00:00',
      end: '24:00',
    })
    const shop = computed(() => store.getters.shop)

    const timeOptions = computed(() => {
      return generateFormatPeriod({
        gap: timeUnit.value,
        offset: timeOffset.value,
      })
    })

    const endOptions = computed(() => {
      const start = timeToNumber(formData.value.start)
      return timeOptions.value.filter(t => {
        return timeToNumber(t) > start
      })
    })

    const findReservationParameter = async () => {
      const res = await FindReservationParameter({ shopId: shop.value })
      timeUnit.value = res.timeUnit || 60
      timeOffset.value = res.timeUnitOffset || 0
    }

    const onConfirm = () => {
      emit('confirm', formData)
      emit('close')
    }

    const onRangeChange = () => {
      setTimeout(() => {
        emit('change')
      }, 300)
    }

    onMounted(async () => {
      await findReservationParameter()
    })

    return {
      formData,
      timeOptions,
      onConfirm,
      endOptions,
      onRangeChange,
    }
  },
})
</script>

<style lang="postcss" scoped>

</style>
